import React from "react";
import Layout from "../../../Components/Layout";
import Schedule from "../../../Components/Schedule/Schedule";

const SchedulePage = () => {
  return (
    <Layout ExtraclassName="event-calendar-panel" activeMenuId="calendar">
      <Schedule />
    </Layout>
  );
};

export default SchedulePage;
